class HomeTimeField extends HTMLElement {
  /**
   * Mirrors the same-day cutoff logic used in the delivery countdown
   * (blocks/price.liquid): Tue-Thu cutoff 15:00, Fri cutoff 13:00.
   * Returns the weekday (0-6) of the day the delivery will actually
   * happen on - today if we're still before today's cutoff, otherwise
   * the next available delivery day.
   */
  static getRelevantDeliveryWeekday() {
    var DELIVERY_DAYS = [2, 3, 4, 5]; // Tuesday - Friday
    var FRIDAY = 5;

    function getCutoffHour(weekday) {
      return weekday === FRIDAY ? 13 : 15;
    }

    var now = new Date();
    var weekday = now.getDay();
    var cutoff = new Date(now);
    cutoff.setHours(getCutoffHour(weekday), 0, 0, 0);

    if (DELIVERY_DAYS.indexOf(weekday) !== -1 && now < cutoff) {
      return weekday;
    }

    var nextDay = new Date(now);
    do {
      nextDay.setDate(nextDay.getDate() + 1);
    } while (DELIVERY_DAYS.indexOf(nextDay.getDay()) === -1);

    return nextDay.getDay();
  }

  connectedCallback() {
    this.#populate();

    if (this.#observer) return;
    this.#observer = new MutationObserver(() => this.#populate());
    this.#observer.observe(this, { childList: true, subtree: true });
  }

  disconnectedCallback() {
    this.#observer?.disconnect();
    this.#observer = null;
  }

  #observer = null;

  #populate() {
    var select = this.querySelector('select');
    if (!select) return;

    // Only the placeholder option means the server re-rendered/reset this field
    // (e.g. after a cart update morph) and the weekday options need to be re-added.
    if (select.options.length > 1) return;

    var isEn = this.dataset.locale === 'en';
    var relevantWeekday = HomeTimeField.getRelevantDeliveryWeekday();
    var FRIDAY = 5;
    var hours = relevantWeekday === FRIDAY ? [14, 15, 16, 17] : [16, 17, 18, 19];

    function formatHourEn(hour) {
      var suffix = hour >= 12 ? 'PM' : 'AM';
      var hour12 = hour % 12 === 0 ? 12 : hour % 12;
      return hour12 + ' ' + suffix;
    }

    var existingValue = this.dataset.existingValue;

    hours.forEach(function (hour) {
      var label = isEn ? 'Home from ' + formatHourEn(hour) : 'Ab ' + hour + ' Uhr zuhause';
      var option = document.createElement('option');
      option.value = label;
      option.textContent = label;
      if (existingValue && existingValue === label) {
        option.selected = true;
      }
      select.appendChild(option);
    });
  }
}

if (!customElements.get('home-time-field')) {
  customElements.define('home-time-field', HomeTimeField);
}
